import CityPageTemplate from "../city-template/CityPageTemplate";
import { fallonConfig } from "./data";

export default function FallonPage() {
  return <CityPageTemplate config={fallonConfig} />;
}